import { render } from "./spinner.vue?vue&type=template&id=24318f8a&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"

import "./spinner.vue?vue&type=style&index=0&id=24318f8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24318f8a"

export default script